import color from './color'
import typography from './typography'
import spacing from './spacing'
import animation from './animation'
import measures from './measures'
import { ThemeType } from './types'
import zIndex from './zIndex'
import utils from './utils'
import colors from '@themes/default/colors'

const defaultTheme = {
  color,
  typography,
  spacing,
  animation,
  measures,
  zIndex,
  utils,
  colors,
} as const satisfies ThemeType<typeof colors>

export default defaultTheme
